import { get, post } from './request.js'//复制代码

export const captchaImage = p => get('captchaImage', p);//验证码
export const login = p => post('login', p);//登录
export const loginOut = p => post('logout', p);//退出登录
export const GetNovelReport = p => get('GetNovelReport', p);//小说统计
export const GetRechargeReport = p => get('GetRechargeReport', p);//充值统计
export const getSummaryReport = p => get('getSummaryReport', p);//汇总统计


// WEBPACK FOOTER //
// ./src/api/api.js